import { TEntityType, TPublicationStatus } from 'src/types/menu.types';

export type EventType = 'DUPLICATE' | 'EXPORT' | 'IMPORT' | 'PUBLISH_PRICING' | 'PUBLISH_PRODUCT' | 'PUBLISH';
export type LogStatus = TPublicationStatus;

export const EVENT_TYPES = {
  DUPLICATE: 'DUPLICATE',
  EXPORT: 'EXPORT',
  IMPORT: 'IMPORT',
  PUBLISH_PRICING: 'PUBLISH_PRICING',
  PUBLISH_PRODUCT: 'PUBLISH_PRODUCT',
  PUBLISH: 'PUBLISH',
} as const;

export const ENTITY_TYPES = {
  PRODUCT: 'PRODUCT',
  MENU: 'MENU',
  PRICE_SCHEME: 'PRICE_SCHEME',
  VENUE: 'VENUE',
  EXTERNAL_SYSTEM: 'EXTERNAL_SYSTEM',
} as const;

export interface IEvent {
  event_id: string;
  entity_type: TEntityType | null;
  entity_id: string | null;
  event_type: EventType;
  status: LogStatus;
  message: string;
  objects: unknown[];
  updated_at: string;
  child_events: IEvent[] | null;
}

export interface IGetEventsParams {
  entity_type?: TEntityType;
  entity_id?: string;
  event_type?: EventType;
  status?: LogStatus;
}

export interface IEventsResponseBody {
  type: string;
  data: IEvent[];
}
